document.addEventListener('DOMContentLoaded', () => {
    const btnList = document.querySelectorAll('.section-description .btn_list')
    const containerDescription = document.querySelectorAll('.container-text_and_img.accordion_content_desktop')
    const containerDescriptionMobile = document.querySelectorAll('.container-text_and_img.accordion_content_movil')

    // Agrega la clase "active" al primer botón y contenedor
    btnList[0].classList.add('active')
    containerDescription[0].classList.add('active')
    containerDescriptionMobile[0].style.maxHeight = "1000px"
    containerDescriptionMobile[0].classList.add('active')
    
    btnList.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        // Elimina la clase "active" de todos los botones y contenedores
        btnList.forEach((btn) => {
          btn.classList.remove('active')
        })
        containerDescription.forEach((container) => {
          container.classList.remove('active')
        })
        containerDescriptionMobile.forEach((container) => {
          container.style.maxHeight = "0"
          container.classList.remove('active')
        })
    
        // Agrega la clase "active" al botón y contenedor correspondientes
        btn.classList.add('active')
        containerDescription[index].classList.add('active')
        containerDescriptionMobile[index].style.maxHeight = "1000px"
        containerDescriptionMobile[index].classList.add('active')
      })
    })
});

